import { render, staticRenderFns } from "./ArtworksKids.vue?vue&type=template&id=67804957&scoped=true"
import script from "./ArtworksKids.vue?vue&type=script&lang=js"
export * from "./ArtworksKids.vue?vue&type=script&lang=js"
import style0 from "./ArtworksKids.vue?vue&type=style&index=0&id=67804957&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67804957",
  null
  
)

export default component.exports